import { render, staticRenderFns } from "./RedeemTicketSuccess.vue?vue&type=template&id=885262fc&scoped=true&"
import script from "./RedeemTicketSuccess.vue?vue&type=script&lang=js&"
export * from "./RedeemTicketSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RedeemTicketSuccess.vue?vue&type=style&index=0&id=885262fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885262fc",
  null
  
)

export default component.exports